CLEAR_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_WITH_DETAILS